import { Player } from 'video-react';

function VideoSection() {
    return (
      <iframe className="video" src="https://www.youtube.com/embed/nj88HMJ4s50?si=AQy76yv556PQFXP_&hd=1" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
    );
  }
  
export default VideoSection;
  